<template>
  <section class="tech-wrapper  pb-5 mt-5">
        <!-- <div class="title mb-5 container">
            <h3>记账报税流程图202412</h3>
            <h4 class="text-1e6ce8 ">Bookkeeping Flowcharts</h4>
        </div> -->
        <div class="title mb-5 container text-center title-hr ">
            <h3>巧记账智能代理记账流程</h3>
            <h4 class="text-1e6ce8 ">BookingAccounting process</h4>
        </div>
        <div class="product-clound01 position-relative container">
            <img :src="productImgClound01" class="img-fluid position-relative" />
            <div class="title">公有云</div>
            <div class="sub">阿里云金融级别双重加密,保障数据信息安全</div>
        </div>
        <div class="bg-f8f6f9">
            <div class="container  chart-main pt-5 pb-5">
                <div class="row p-5 justify-content-center ">
                    <div class="col-10 position-relative">
                        <img :src="productImg" class="img-fluid position-relative" />
                        <div class=" text-center mb-3  mt-3 clearfix chart-item position-absolute" style="width:18%;top:6%;left:18%">
                            <span class=" d-inline-block chart-i" style="width: 100px;height: 75px;"></span>
                            <div class=" chart-hover text-left" style="left: -38.5%;">
                                <!-- <span class="triangle" style="left: 17.5%;"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">01</span>
                                于电子税务局底账中自动抓取本公司抬头的原始票据(如收入、支出票据，社保公积金文件等)                        </div>
                        </div>
                        <div class="text-center mb-3  mt-3 clearfix  chart-item position-absolute" style="width:15%;top:6%;left:42.5%">
                            <span class=" d-inline-block chart-i" style="width: 80px;height: 75px;"></span>
                            <div class=" chart-hover text-left" style="right: -237%;">
                                <!-- <span class="triangle" style="left: 46%;"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">02</span>
                                支持用户自助上传末含公司抬头的费用发票(如定额发票等)</div>
                        </div>
                        <div class=" text-center mb-3  mt-3 clearfix  chart-item position-absolute" style="width:18%;top:6%;left:61.5%">
                            <span class=" d-inline-block chart-i" style="width: 96px;height: 75px;"></span>
                            <div class=" chart-hover text-left" style="right: -157%;">
                                <!-- <span class="triangle" style="left:64.5%"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">03</span>
                                巧记账已与工商银行,建设银行,民生银行,中国银行对接银企直连合作,企业基本户是上述银行的情況下,不再需要每月繁琐上传,一次授权,全自动抓取</div>
                        </div>
                        <div class=" text-center mb-3  mt-3 clearfix  chart-item position-absolute" style="width:15%;top:6%;left:81.5%">
                            <span class=" d-inline-block chart-i" style="width: 80px;height: 75px;"></span>

                            <div class=" chart-hover text-left" style="right: -40%;left: auto;">
                                <!-- <span class="triangle " style="left:82%"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">04</span>
                                识别白动抓取/上传的票据信息,智能完成对应的会计归类</div>
                        </div>
                        <div class="text-center mb-3  mt-3 clearfix chart-item  position-absolute" style="width:15%;top:29%;left:81.5%">
                            <span class=" d-inline-block chart-i" style="width:194px;height:150px;"></span>
                            <div class=" chart-hover text-left" style="right: -140%;left: auto; top:107%">
                                <!-- <span class="triangle" style="left:81.5%"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">05</span>
                                机巧采用最先讲的AI技术以及多名资深财务总监制定的做账逻辑自动帮用户完成做账工作。系统自动做账完毕后,将由专业财务老师人工申核,确保做账质量。电子账本账册可展现至二级会计分录明细,会计凭证与原始票据完整对应                            </div>
                        </div>
                        <div class=" text-center mb-3  mt-3 clearfix chart-item  position-absolute" style="width:15%;top: 78%;right: 4%;">
                            <span class=" d-inline-block chart-i" style="width: 80px;height: 95px;"></span>
                            <div class=" chart-hover text-left" style="    right: -140%;left: auto;bottom: -40px;">
                                <!-- <span class="triangle" style="left: 9.5%;"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">06</span>
                                提供一般纳税人企业进项票认证支持，自动计算并生成本期应纳税金额。</div>
                        </div>
                        <div class="  text-center mb-3  mt-3 clearfix chart-item position-absolute" style="width:15%;top: 78%;right: 19%;">
                            <span class=" d-inline-block chart-i" style="width:160px;height: 95px;"></span>
                            <div class=" chart-hover text-left" style=" right: -189%;left: auto;bottom: -40px;">
                                <!-- <span class="triangle" style="left: 35.5%;"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">07</span>
                                漏报会导致异常，我们将通过专属群消息、公众号及邮箱三重提醒。
                            </div>
                        </div>
                        <div class=" text-center mb-3  mt-3 clearfix chart-item  position-absolute" style="width:15%;top: 78%;right: 36.5%;">
                            <span class=" d-inline-block chart-i" style="width: 80px;height: 95px;"></span>
                            <div class=" chart-hover text-left" style="    right: -200%;left: auto;bottom: -40px;">
                                <!-- <span class="triangle" style="left: 63.5%;"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">08</span>
                                如无异议,点击“确认”一键完成申报纳税;如有疑问,可用VIP服务群向专属财务老师咨询;</div>
                        </div>
                        <div class=" text-center mb-3  mt-3 clearfix chart-item position-absolute" style="width:15%;top: 78%;right: 51.5%;">
                            <span class=" d-inline-block chart-i" style="width: 80px;height: 95px;"></span>
                            <div class=" chart-hover text-left" style="right: -242%;left: auto;bottom: -40px;">
                                <!-- <span class="triangle" style="left: 81.5%;"><em></em></span> -->
                                <span class="circle" style="left: -0.5%;">09</span>
                                保持银行基本户余额满足税金扣款即可,无需额外操作。执行成功后，推送反馈结果</div>
                        </div>

                    </div>
                    <div class="col-2 position-relative">
                        <img :src="productImgChart" class="img-fluid position-relative" />
                        <div class="product-AI">
                            <div class="text-center h3">AI智能支持</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能识别</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能归类</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能开票</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能认证</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能填单</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能审核</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能RPA</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能申报</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能提醒</div>
                            <div class="li"><b-icon icon="check"></b-icon>虚拟CFO</div>
                            <div class="li"><b-icon icon="check"></b-icon>智能分析</div>
                        </div>

                    </div>
                    <div class="row mt-5 text-center">（前端完整精确账务数据信息采集，中台智能运算和数据共享传输，后端按时准确纳税申报及反馈推送）</div>
                </div>
            </div>

        </div>
        <div class="product-clound02 position-relative container">
            <img :src="productImgClound02" class="img-fluid position-relative" />
            <div class="title">基础层</div>
            <div class="sub">WINDOWS/IOS/ANDROID 操作系统</div>
            <div class="sub">主数据,会计引擎,规则引擎,数据中台,Al中台,电子档案,任务管理,知识管理</div>
        </div>
    </section>
</template>
<script>
export default {
  name: 'Bookkeeping',
  data () {
    return {
      list: [],
      productImg: require('../../../assets/image/jq-product-lc-bg.png'),
      productImgChart:require('../../../assets/image/img-product-chart.png'),
      productImgClound01:require('../../../assets/image/img-product-cloud-01.png'),
      productImgClound02:require('../../../assets/image/img-product-cloud-02.png'),

    }
  },
  mounted () {
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Product/components/Bookkeeping2024.vue